import { defineMessages } from 'react-intl';

export const scope = 'source_list';

export default defineMessages({
    mongo_excel_check: {
        id: `${scope}.mongo_excel_check`,
        defaultMessage: 'MongoDB is not allowed when excel analytics is enabled.',
    },
    extraction_excel_check: {
        id: `${scope}.extraction_excel_check`,
        defaultMessage: 'Ameya Extraction is not allowed when excel analytics is enabled.',
    },
    usage_type_check: {
        id: `${scope}.usage_type_check`,
        defaultMessage: 'Please select usage type first.',
    },
    mongo_check: {
        id: `${scope}.mongo_check`,
        defaultMessage: 'MongoDB cannot be selected with other sources.',
    },
    ameya_extract_check: {
        id: `${scope}.ameya_extract_check`,
        defaultMessage: 'Ameya Extract cannot be selected with other sources.',
    },
    appflyte_check: {
        id: `${scope}.appflyte_check`,
        defaultMessage: 'Appflyte cannot be selected with other sources.',
    },
    dataset_name_check: {
        id: `${scope}.dataset_name_check`,
        defaultMessage: 'Please enter a dataset name and try again.',
    },
    source_select_check: {
        id: `${scope}.source_select_check`,
        defaultMessage: 'Please select a data source and try again.',
    },
    dataset_name_existence: {
        id: `${scope}.dataset_name_existence`,
        defaultMessage: 'A dataset with this name already exists.',
    }
});
